export const clientLayoutStateKey = 'clientLayout';
export const tenantLayoutStateKey = 'tenant-layout';
